import { useHistory } from "react-router-dom"
import styles from "../../css/payments/explore-pricing.module.css";

export const SelectPlanButton = ({ extraStyles, buttonText, stripePriceId }) => {
    const history = useHistory();

    const onPlanSelection = (e) => {
        e.stopPropagation()
        history.push('/renew-subscription', { priceId: stripePriceId })
    }

    return (
        <button
            className={styles.selectButton}
            onClick={(e) => onPlanSelection(e)}
            style={extraStyles}
        >
            {buttonText}
        </button>
    )
}